<div class="modal--wrap panel-show"
     ngxModalDraggable
     [expand]="true"
>
  <app-modal-header
    icon="video"
    title="Обущающее видео"
    [modalDirective]="modalDirective"
    [bsModalRef]="bsModalRef"
    [expand]="true"
    [minimized]="true"
  ></app-modal-header>
  <div class="modal-body p-0">
    <div class="d-flex">
      <iframe class="video" width="100%" height="400px" src="https://rutube.ru/play/embed/b82dd821a23383e22fac01b1feccd9ac/" frameBorder="0" allow="clipboard-write; autoplay" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>
    </div>
  </div>
</div>
